export const ewallet = {
    account: null
} 